<app-tab-header>
  <div class="d-flex">
    <div class="ms-auto">
      <button type="button" [hidden]="true" kendoButton (click)="refreshData()" [svgIcon]="icons.refresh" fillMode="clear"></button>

      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.folderOpen"
        [disabled]="selectedItems.length === 0 || selectedItems.length > 1" (click)="createTab()">Open</button>

      <span title="This button will sync WBS status from Execute to the estimates below, will enable revisions for rejected or approved states">
        <button type="button" kendoButton themeColor="primary" [buttonLoading]="isAfeSyncInProgress" [svgIcon]="icons.refresh"
          [disabled]="afeNumber === null || isAfeSyncInProgress" (click)="updateAfeStatus()">Sync WBS Status</button>
      </span>

      <button type="button" kendoButton [buttonLoading]="isCreatingDraft" themeColor="primary" [svgIcon]="icons.plusCircle"
        [disabled]="hasDraftEstimate || disableAllEdits() || isCreatingDraft" (click)="createDraft()">
        Create</button>
      <button type="button" kendoButton [buttonLoading]="copying" themeColor="primary" [svgIcon]="icons.copy"
        [disabled]="selectedItems.length !== 1 || isDraftSelected() || disableAllEdits()"
        (click)="handleCopyEstimate()">
        Copy
      </button>
      @if (showEstimateCompareButton) {
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.swap"
          [disabled]="selectedItems.length !== 2" (click)="compareEstimates()">Compare</button>
      }
      <button type="button" kendoButton [buttonLoading]="isDeleting" themeColor="primary" [svgIcon]="icons.trash"
        [disabled]="isDeleting || selectedItems.length === 0 || anyNonDraftsSelected() || disableAllEdits() "
        (click)="displayDraftDeleteDialog = true">
        Delete</button>
    </div>
  </div>

</app-tab-header>

<kendo-grid style="margin: 5px 15px 15px 15px;" [data]="gridView" [sortable]="{ mode: 'multiple' }" [sort]="sortData"
  [reorderable]="true" (sortChange)="sortDataChange($event)" (selectionChange)="selectionChange($event)"
  (edit)="editHandler($event)" [kendoGridSelectBy]="'ProjectEstimateId'" [selectedKeys]="selectedKeys"
  [selectable]="selectableSettings" [resizable]="true">
  <kendo-grid-checkbox-column [reorderable]="false" [width]="25" [showSelectAll]="false"></kendo-grid-checkbox-column>

  <kendo-grid-column field="EstimateVersion" title="Estimate / ID Version" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span (dblclick)="onRowDblClick($event,dataItem,rowIndex)" [class.highlight-row]="dataItem.isSelected"
        style="cursor:pointer">
        V{{dataItem.EstimateVersion}} / {{convertedProjectId}}
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="ProjectEstimateStatus.Description" title="Status" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.ProjectEstimateStatus.Description}}
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="EstimateTotal" title="Total" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.EstimateTotal | currency:'USD':'symbol-narrow' }}
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="Updated" title="Modified Date" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.Updated | date:'shortDate'}}
      </span>
    </ng-template>

  </kendo-grid-column>
  <kendo-grid-column field="Created" title="Created Date" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.Created | date:'shortDate'}}
      </span>
    </ng-template>

  </kendo-grid-column>
  <kendo-grid-column field="CreatedBy" title="Created By" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.CreatedBy}}
      </span>
    </ng-template>

  </kendo-grid-column>

  <kendo-grid-column field="AFEUpdateReason.Description" title="Update Reason" [width]="90">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span [class.highlight-row]="dataItem.isSelected">
        {{dataItem.AFEUpdateReason?.Description || ''}}
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="WorkFlow" title="Link" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.AfeVersionDocumentId) {
        <div>
          <a [href]="urlExecuteAfe + 'ui/view?AFE/' + dataItem.AfeVersionDocumentId" target="_blank">
            <kendo-svgicon [icon]="icons.hyperlinkOpen" style="padding-top:2px; color: #0044cc"></kendo-svgicon>
            Execute
          </a>
        </div>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="AfeVersionDocumentId" title="Version Doc Id" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      @if (dataItem.AfeVersionDocumentId) {
        <span [class.highlight-row]="dataItem.isSelected">
          {{dataItem.AfeVersionDocumentId}}
        </span>
      }
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="AFEVersion" title="WBS Version" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      @if (afeNumber) {
        <span [class.highlight-row]="dataItem.isSelected">
          {{ dataItem.AFEVersion ? (afeNumber + ' - ' + dataItem.AFEVersion) : afeNumber }}
        </span>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="RecordStatus" title="Record Status" [width]="60">
  </kendo-grid-column>
  <kendo-grid-command-column title="Notes" [width]="30">
    <ng-template kendoGridCellTemplate let-editDataItem>
      <a kendoGridEditCommand [ngStyle]="{'background-color': editDataItem.RecordDescription ? 'lightgreen' : 'inherit'}">
        <kendo-svgicon [icon]="icons.editTools" style="padding-top:2px;padding-left:0px;color:#4d88ff"></kendo-svgicon>
      </a>
    </ng-template>
  </kendo-grid-command-column>
  <kendo-grid-column field="IsForecastOverride" editible="false" title="Forecast Override" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem>
      <input kendoCheckBox class="k-checkbox" type="checkbox" [checked]="dataItem.IsForecastOverride" (change)="onIsForecastOverrideChange(dataItem, $event)" />
    </ng-template>
  </kendo-grid-column>
</kendo-grid>

<app-estimate-notes-form [model]="editDataItem" (save)="saveHandler($event)" (cancel)="cancelHandler()">
</app-estimate-notes-form>

<div kendoDialogContainer></div>

@if (displayEstimateCopyDialog) {
  <kendo-dialog>
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em;">
        <kendo-svgicon [icon]="icons.warning" style="margin-bottom: 3px"></kendo-svgicon> Current Draft Estimate Will Be Deleted
      </div>
    </kendo-dialog-titlebar>
    <p style="margin: 30px; text-align: center;">This action will cause the current Draft estimate to be deleted. Would
      you like to proceed?
    </p>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="acceptCopyEstimate()" themeColor="primary">Yes</button>
      <button type="button" kendoButton (click)="declineCopyEstimate()">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (showForecastOverride) {
  <kendo-dialog (close)="cancelForecastOverride()">
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em;">
        <kendo-svgicon [icon]="icons.warning" style="margin-bottom: 3px"></kendo-svgicon> Forecast Override
      </div>
    </kendo-dialog-titlebar>
    <p style="margin: 30px; text-align: center;">You should only modify this option if you are responsible for the forecast of this particular project. Do you wish to continue?
    </p>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="acceptForecastOverride()" themeColor="primary">Yes</button>
      <button type="button" kendoButton (click)="cancelForecastOverride()">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (copying) {
  <kendo-dialog title="Estimate Copy in Progress" (close)="closeCopyDialog()">
    <div class="copy-dialog-container">
      <p>
        This may take up to 60 seconds or longer for large projects
      </p>
    </div>
  </kendo-dialog>
}

@if (displayDraftDeleteDialog) {
  <kendo-dialog>
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em;">
        <kendo-svgicon [icon]="icons.warning" size="large" style="margin-bottom: 3px"></kendo-svgicon> Current Draft Estimate Will Be Deleted
      </div>
    </kendo-dialog-titlebar>
    <p style="margin: 30px; text-align: center;">This action will cause the current Draft estimate to be deleted. Would
      you like to proceed?
    </p>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="acceptDeleteDraft()" themeColor="primary">Yes</button>
      <button type="button" kendoButton (click)="displayDraftDeleteDialog = false">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (displayCompareDialog) {
  <kendo-dialog title="Compare Estimate" (close)="closeCompareDialog()" [width]="1100"
    [height]="650">
    <kendo-tabstrip #tabStrip [keepTabContent]="true">
      <kendo-tabstrip-tab title="By Phase Step" [selected]="true">
        <ng-template kendoTabContent>
          @if (loading) {
            <kendo-loader type="converging-spinner" size="small" style="margin-left: 1rem; margin-top:0.25rem;"></kendo-loader>
          }
          <kendo-grid style="margin: 5px 15px 15px 15px;" [data]="estimateCompareData" [selectable]="selectableSettings"
            [groupable]="true" [group]="state.group" (dataStateChange)="onStateChange($event)" [height]="500">
            <kendo-grid-column field="Phase" title="Phase" [width]="90">
              <ng-template kendoGridGroupHeaderTemplate let-group="group" let-aggregates="aggregates">
                <span title="">
                  Phase: {{group.value}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Step" title="Step" [width]="90">
              <ng-template kendoGridGroupHeaderTemplate let-group="group" let-aggregates="aggregates">
                <span title="">
                  Step: {{group.value}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CostCodeValue" title="Cost Code" [width]="60">
            </kendo-grid-column>
            <kendo-grid-column field="CostTypeValue" title="Cost Type" [width]="60">
            </kendo-grid-column>
            <kendo-grid-column field="Estimate1Total" title="{{EstimateOne}}" format="{0:c}" [width]="120">
              <ng-template kendoGridFooterTemplate>
                <span title="">
                  {{totalEstimateOne | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
              <ng-template kendoGridGroupHeaderColumnTemplate let-group="group" let-aggregates="aggregates">
                <span title="">
                  {{aggregates.Estimate1Total.sum | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Variance" title="Variance" format="{0:c}" [width]="90"
              [style]="{'background-color': '#ffe6cc'}">
              <ng-template kendoGridFooterTemplate>
                <span title="">
                  {{totalVariance | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
              <ng-template kendoGridGroupHeaderColumnTemplate let-group="group" let-aggregates="aggregates">
                <span title="">
                  {{aggregates.Variance.sum | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Estimate2Total" title="{{EstimateTwo}}" format="{0:c}" [width]="120">
              <ng-template kendoGridFooterTemplate>
                <span title="">
                  {{totalEstimateTwo | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
              <ng-template kendoGridGroupHeaderColumnTemplate let-group="group" let-aggregates="aggregates">
                <span title="">
                  {{aggregates.Estimate2Total.sum | currency:'USD':'symbol-narrow'}}
                </span>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="By Parameters">
        <ng-template kendoTabContent>
          <kendo-grid style="margin: 5px 15px 15px 15px;" [data]="EstimateParameterData" [selectable]="selectableSettings"
            [height]="250">
            <kendo-grid-column field="Name" title="Parameter">
            </kendo-grid-column>
            <kendo-grid-column field="Value1" title="{{EstimateOne}}">
            </kendo-grid-column>
            <kendo-grid-column field="Value2" title="{{EstimateTwo}}">
            </kendo-grid-column>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </kendo-dialog>
}